
const TradeMode = {
  'DEAL': 0, // 公开协商
  'LISTING': 1, // 预挂牌
  'HISTORY': 2, // 历史备案
  'AUCTION': 3, // 公开竞价
  'RENEWAL': 4, // 续约交易
  'SMALL_SIMPLE': 5 // 小额交易
}

const TradeModeText = {
  0: '公开协商',
  1: '预挂牌',
  2: '历史备案',
  3: '公开竞价',
  4: '续约交易',
  5: '小额交易'
}

const ModeTrade = {
  0:'deal',
  1:'listing',
  2:'history',
  3:'auction',
  4:'renewal',
  5:'small',
}

export {
  TradeMode,
  TradeModeText,
  ModeTrade
}
